export const CommonlyUsedCountries = {
  US: 'US',
  CA: 'CA',
  IL: 'IL',
}
